// extracted by mini-css-extract-plugin
module.exports = {"answerBlock":"Answer_answerBlock__12DoT","answerBlock__icon":"Answer_answerBlock__icon__mzDQv","answerBlock__text":"Answer_answerBlock__text__30SRf","spin":"Answer_spin__2gHKc"};